/**
 * Route loader for GroupedBrowsePage
 *
 * Fetches titles data before rendering to eliminate loading spinners.
 * React Router automatically caches loader results for back/forward navigation.
 */

import type { ApiTitle } from "@lumi/data";
import { apiCall } from "../config/api";

export interface BrowseLoaderData {
  titles: ApiTitle[];
}

/**
 * Loader function for browse route
 *
 * Loads public title data. Watchlist filtering is handled in the component
 * via FilterPanel since it requires authentication context.
 */
export async function browseLoader(): Promise<BrowseLoaderData> {
  // Fetch all titles (public endpoint)
  const response = await apiCall("/v1/titles");
  if (!response.ok) {
    throw new Error(`Failed to fetch titles: ${response.status} ${response.statusText}`);
  }

  const titles = (await response.json()) as ApiTitle[];
  return { titles };
}
